var $615f888e9fb9e405$exports = {};
$615f888e9fb9e405$exports = {
    "endTime": `Eindtijd`,
    "startTime": `Starttijd`,
    "time": `Tijd`
};


export {$615f888e9fb9e405$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
